import RetirementPlan from "./RetirementPlan"
import ESHCPlan from "./ESHCPlan"
import SEPPlan from "./SEPPlan"
import SocialSecurity from "./SocialSecurity"
import GroupLifePlan from "./GroupLifePlan"
import PensionPlan from "./PensionPlan"
import MXHCPlan from "./MXHCPlan"

export const benefitWorksheets = {
  RetirementPlan,
  ESHCPlan,
  SEPPlan,
  SocialSecurity,
  GroupLifePlan,
  PensionPlan,
  MXHCPlan
}
